(() => {
  const modal = document.getElementById('UserStoryViewerModal');
  if (!modal) return;

  const closeBtn = modal?.querySelector('.viewer-ui-close');
  const panel = modal.querySelector('.userstory-viewer-modal__panel');
  const backdropClose = modal.querySelector('[data-userstory-viewer-close]');
  const modelViewer =
    modal.querySelector('model-viewer') ||
    modal.querySelector('#UserStoryViewerModal') || // viewer_id を付けてる場合の保険
    null;

  // ないと何もできないのでガード
  if (!modelViewer) return;

  const openModal = () => {
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('is-locked'); // 必要ならCSSでスクロール止める
    document.body.classList.add('is-locked');
  };

  const closeModal = () => {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('is-locked');
  };

  // Escで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // 背景クリックで閉じる
  if (backdropClose) {
    backdropClose.addEventListener('click', closeModal);
  }

  // モーダル内クリックは閉じない
  if (panel) {
    panel.addEventListener('click', (e) => e.stopPropagation());
  }

  // 360°ボタン（複数）クリック → src差し替え → モーダル展開
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-user-story-360');
    if (!btn) return;

    e.preventDefault();

    if (closeBtn) closeBtn.style.display = 'flex';

    const glb = btn.getAttribute('data-glb');
    if (!glb) return;

    // 先に差し替え（読み込み開始）
    if (modelViewer.getAttribute('src') !== glb) {
      modelViewer.setAttribute('src', glb);
    }

    // クリックしてからモーダル展開
    openModal();
  });

  closeBtn?.addEventListener('click', () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    closeBtn.style.display = 'none';
  });
})();

(() => {
  const viewerModal = document.getElementById('UserStoryViewerModal');
  if (!viewerModal) return;

  const mv = viewerModal.querySelector('model-viewer');
  if (!mv) return;

  // ---------------------------------------
  // AR可否でボタン表示・文言切替
  // ---------------------------------------
  function applyButtonsByARSupport(canAR) {
    // model-viewerモーダルを開くボタン（既存 .js-user-story-360）
    document.querySelectorAll('.js-user-story-360').forEach((btn) => {
      const text = btn.querySelector('.viewer-btn-text');
      const icon360 = btn.querySelector('.icon-360');
      const iconAR = btn.querySelector('.icon-ar');
      if (!text || !icon360 || !iconAR) return;

      if (canAR) {
        // AR対応：このボタンをARボタン見た目に
        text.textContent = 'ARで試し置き';
        icon360.hidden = true;
        iconAR.hidden = false;
        btn.classList.add('is-ar');
        btn.hidden = false;
      } else {
        // AR非対応：360ボタンのまま
        text.textContent = '360°で試す';
        icon360.hidden = false;
        iconAR.hidden = true;
        btn.classList.remove('is-ar');
        btn.hidden = false;
      }
    });

    // 非AR用（QRモーダルを開く）ボタン
    document.querySelectorAll('.js-user-story-ar-qr').forEach((btn) => {
      // AR対応なら不要、非対応なら表示
      btn.hidden = !!canAR;
    });
  }

  function updateARUI() {
    const canAR = !!mv.canActivateAR;
    applyButtonsByARSupport(canAR);
  }

  updateARUI();
  mv.addEventListener('load', updateARUI);
  setTimeout(updateARUI, 300);
  setTimeout(updateARUI, 1000);

  // ---------------------------------------
  // QRモーダル：ボタンに紐づく .once-ar-modal を開く
  // ---------------------------------------
  function openOnceArModal(modalEl) {
    if (!modalEl) return;
    modalEl.hidden = false;
    document.documentElement.classList.add('is-locked');
    document.body.classList.add('is-locked');
  }

  function closeOnceArModal(modalEl) {
    if (!modalEl) return;
    modalEl.hidden = true;
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('is-locked');
  }

  // QRボタン押下
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-user-story-ar-qr');
    if (!btn) return;

    e.preventDefault();

    // 同じストーリー内にあるモーダルを探す（btn-area内に置いてるので近い）
    const scope = btn.closest('.btn-area') || btn.parentElement;
    const modalEl =
      scope?.querySelector('.once-ar-modal') ||
      btn.closest('.user-story')?.querySelector('.once-ar-modal');

    openOnceArModal(modalEl);
  });

  // 閉じる（overlay / close btn のどちらでも）
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-ar-modal-close]');
    if (!close) return;

    const modalEl = close.closest('.once-ar-modal');
    closeOnceArModal(modalEl);
  });

  // Escで閉じる（開いてるもの全部閉じる）
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document
      .querySelectorAll('.once-ar-modal:not([hidden])')
      .forEach((m) => closeOnceArModal(m));
  });
})();
